import React from "react";

// Fixed HUD overlay chrome: corner brackets, scanlines, telemetry ticker.
export function HudOverlay() {
  return (
    <div className="pointer-events-none fixed inset-0 z-40" data-testid="hud-overlay">
      {/* corner brackets */}
      <Corner pos="top-4 left-4" dirs="border-t-2 border-l-2" />
      <Corner pos="top-4 right-4" dirs="border-t-2 border-r-2" />
      <Corner pos="bottom-4 left-4" dirs="border-b-2 border-l-2" />
      <Corner pos="bottom-4 right-4" dirs="border-b-2 border-r-2" />
      {/* scanlines */}
      <div className="absolute inset-0 hud-scanlines opacity-60" />
    </div>
  );
}

function Corner({ pos, dirs }) {
  return (
    <div
      className={`absolute ${pos} w-7 h-7 ${dirs} border-cyan/40 animate-flicker`}
    />
  );
}

export function Telemetry() {
  const blocks = [
    "AETHER CORE v2.6", "UPLINK STABLE", "SECTOR SYNC 100%", "VFX PIPELINE ONLINE",
    "NEURAL MESH ACTIVE", "QUANTUM RENDER READY", "MODEL-AGNOSTIC LAYER OK",
  ];
  return (
    <div className="w-full overflow-hidden border-y border-cyan/15 bg-black/40 py-1.5" data-testid="telemetry-ticker">
      <div className="ticker font-mono text-[10px] tracking-[0.25em] text-cyan/70">
        {[...blocks, ...blocks].map((b, i) => (
          <span key={i} className="mx-6 flex items-center gap-2">
            <span className="text-amber">◆</span> {b}
          </span>
        ))}
      </div>
    </div>
  );
}
